import { createRouter, createWebHistory } from 'vue-router';
import ComingSoon from "@/views/ComingSoon.vue";
import Home from '@/views/Home.vue';
import Products from '@/views/Products.vue';
import AboutUs from '@/views/AboutUs.vue';
import Blog from '@/views/Blog.vue';
import Contact from '@/views/Contact.vue';

let isAuthenticated = false; // Track if the user is logged in

export function authenticate() {
    isAuthenticated = true; // Allow access to protected routes
}

const routes = [
    { path: "/", name: "ComingSoon", component: ComingSoon }, // Public
    { path: "/home", name: "Home", component: Home }, // Protected
    { path: "/products", name: "Products", component: Products }, // Protected
    { path: "/about-us", name: "AboutUs", component: AboutUs }, // Protected
    { path: "/blog", name: "Blog", component: Blog }, // Protected
    { path: "/contact", name: "Contact", component: Contact }, // Protected
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

// Global navigation guard
router.beforeEach((to, from, next) => {
    if (to.path === "/" || isAuthenticated) {
        // Allow access to "Coming Soon" or authenticated routes
        next();
    } else {
        // Redirect unauthenticated users to the "Coming Soon" page
        next("/");
    }
});

export default router;
